import React, { useEffect, useState, useRef } from 'react';
import { MDBContainer, MDBRow, MDBSpinner } from 'mdbreact';
import { toast } from 'react-toastify';

import NavBar from '../../../components/NavBar';
import api from '../../../services/api';

// Dashboard Detalhado — embute um dashboard do Metabase via Embedding SDK.
// O token JWT e gerado no BACKEND (/metabase-embed-token); a secret nunca
// trafega pelo front. Fluxo:
//   1) injeta o script embed.js da instancia do Metabase
//   2) chama defineMetabaseConfig (tema + instanceUrl)
//   3) busca o token assinado no backend
//   4) renderiza o web component <metabase-dashboard token={...}>
export default function DashboardDetalhado() {
  const [token, setToken] = useState(null);
  const [instanceUrl, setInstanceUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(false);
  const scriptInjetado = useRef(false);

  // injeta o embed.js + config assim que soubermos a instanceUrl
  const injetaEmbedScript = url => {
    if (scriptInjetado.current) return;
    scriptInjetado.current = true;

    // defineMetabaseConfig precisa existir antes do embed.js rodar.
    // locale: tentamos varias formas aceitas pelo SDK do Metabase
    // ('pt-BR', 'pt' e 'pt_BR') para forcar o portugues no guest embed.
    window.defineMetabaseConfig = config => {
      window.metabaseConfig = config;
    };
    window.defineMetabaseConfig({
      theme: { preset: 'light' },
      isGuest: true,
      instanceUrl: url,
      locale: 'pt-BR',
      language: 'pt-BR',
    });

    const script = document.createElement('script');
    // ?locale tambem propaga a preferencia de idioma para o embed.js
    script.src = `${url}/app/embed.js?locale=pt`;
    script.defer = true;
    document.body.appendChild(script);
  };

  const carregaDashboard = async () => {
    setLoading(true);
    setErro(false);
    try {
      const { data } = await api.get('/metabase-embed-token');
      if (!data || !data.token) {
        throw new Error('Token nao recebido');
      }
      injetaEmbedScript(data.instanceUrl);
      setInstanceUrl(data.instanceUrl);
      setToken(data.token);
    } catch (e) {
      setErro(true);
      toast.error('Falha ao carregar o dashboard.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregaDashboard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <NavBar />
      <MDBContainer fluid className="mt-3">
        {loading && (
          <MDBRow center className="my-5 align-items-center">
            <MDBSpinner yellow />
            <div className="ml-3 font-weight-bolder">Carregando...</div>
          </MDBRow>
        )}

        {erro && !loading && (
          <MDBRow center className="my-5 font-weight-bolder text-danger">
            Não foi possível carregar o dashboard.
          </MDBRow>
        )}

        {token && instanceUrl && !erro && (
          <div style={{ width: '100%', minHeight: '80vh' }}>
            {/* web component do Metabase Embedding SDK */}
            <metabase-dashboard
              token={token}
              locale="pt-BR"
              with-title="true"
              with-downloads="true"
              style={{ width: '100%', height: '80vh', display: 'block' }}
            />
          </div>
        )}
      </MDBContainer>
    </>
  );
}
